var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"board-detail-status"},[_c('device-component-list-modem',{ref:"list",attrs:{"modemSn":_vm.modemSn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }